module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-55Rg.d33b38b.woff2";